var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCamera = function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "camera_svg__Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".camera_svg__st0{fill:#666}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "camera_svg__Icon-Camera",
    transform: "translate(178 530)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "camera_svg__Fill-21_1_",
    className: "camera_svg__st0",
    d: "M-136.6-488.8h-34.3c-2 0-3.7-1.7-3.7-3.7v-22c0-2 1.7-3.7 3.7-3.7h7.4c.2 0 .6-.3.7-.4l1.3-2.7c.5-1 1.8-1.8 2.9-1.8h9.7c1.1 0 2.4.8 2.9 1.8l1.3 2.7c.1.2.4.4.7.4h7.4c2 0 3.7 1.7 3.7 3.7v22c0 2-1.6 3.7-3.7 3.7zm-34.2-26.9c-.7 0-1.2.5-1.2 1.2v22c0 .7.5 1.2 1.2 1.2h34.3c.7 0 1.2-.5 1.2-1.2v-22c0-.7-.5-1.2-1.2-1.2h-7.4c-1.1 0-2.4-.8-2.9-1.8l-1.3-2.7c-.1-.2-.4-.4-.7-.4h-9.7c-.2 0-.6.3-.7.4l-1.3 2.7c-.5 1-1.8 1.8-2.9 1.8h-7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "camera_svg__Fill-22_1_",
    className: "camera_svg__st0",
    d: "M-153.7-493.7c-6.1 0-11-4.9-11-11s4.9-11 11-11 11 4.9 11 11-4.9 11-11 11zm0-19.6c-4.7 0-8.6 3.9-8.6 8.6s3.9 8.6 8.6 8.6 8.6-3.9 8.6-8.6-3.8-8.6-8.6-8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "camera_svg__Fill-23_1_",
    className: "camera_svg__st0",
    d: "M-140.2-513.3c0 .7-.5 1.2-1.2 1.2s-1.2-.5-1.2-1.2.5-1.2 1.2-1.2c.6 0 1.2.6 1.2 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "camera_svg__Fill-24_1_",
    className: "camera_svg__st0",
    d: "M-169.6-520.6h4.9v1.2h-4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "camera_svg__Fill-25_1_",
    className: "camera_svg__st0",
    d: "M-153.7-509.6v-1.2c-3.3 0-6.1 2.7-6.1 6.1h1.2c0-2.7 2.2-4.9 4.9-4.9"
  }))));
};
export default SvgCamera;